<template>
  <IconLucideTableProperties />
</template>
